<template>
  <searchable-datatable
    id="inactive-calls-table"
    v-model="search"
    :source="source"
    :filters="appliedFilters"
    :config="config"
    :map-records="applyFilter"
  ></searchable-datatable>
</template>

<script>
import { getPathValueAt } from "@/lib/url.js";

import SearchableDatatable from "@/components/SearchableDatatable.vue";
import CallModalLink from "@/CallComponents/CallModalLink.vue";
import LinkInactiveCallLink from "@/CallComponents/LinkInactiveCallLink.vue";
import store from "@/vuex/store";

export default {
  components: {
    SearchableDatatable
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      search: "",
      config: {
        pageLength: 10,
        dom: "rtip",
        order: [[3, "desc"]],
        columns: [
          { data: "call_id", title: "Call ID" },
          { data: "call_status", title: "Status", orderData: 2 },
          { data: "call_status_alpha", visible: false, searchable: false },
          { data: "start_time", title: "Start Time" },
          { data: "claimed_by", title: "Assigned To" },
          { data: "caller_id", title: "Caller ID" },
          { data: "phone", title: "Phone #" },
          { data: "linked", title: "Linked" },
          {
            data: "link_action",
            title: "Link",
            orderable: false,
            className: "text-center"
          }
        ],
        vueComponents: [
          {
            rootId: "link-inactive-call-link-vue",
            component: LinkInactiveCallLink,
            options: {
              store
            }
          },
          {
            rootId: "call-modal-link-vue",
            component: CallModalLink,
            options: {
              store
            }
          }
        ]
      }
    };
  },
  computed: {
    appliedFilters() {
      return this.filters.filter((filter) => {
        return this.config.columns.some((col) => {
          return filter.name === col.filterName || filter.name === col.data;
        });
      });
    }
  },
  methods: {
    applyFilter(record) {
      // Find customer/job id
      // apply that key to the record
      const entity = getPathValueAt(0); // jobs|customers
      const id = getPathValueAt(1); // id

      // linkable type and id are set to create the link/unlink URLs
      if (entity === "customers") {
        record.linkable_type = "User";
        record.linkable_id = id;
      }
      if (entity === "jobs") {
        record.linkable_type = "Job";
        record.linkable_id = id;
      }

      return record;
    }
  }
};
</script>

<style lang="scss" scoped></style>
